module.exports = "https://trybtryb-legacy.web.app/img/google_maps.0ccb92f7.svg";